import { useActions } from '../store'

const useErrorHandler = () => {
  const { setError } = useActions()

  const handleError = (error, message) => {
    if (error?.message === 'Failed to fetch') {
      setError('Unable to connect to services')
    } else {
      setError(error.message || message)
    }
  }

  return { handleError }
}

export { useErrorHandler }
